import {Action, createAction, createReducer, createSelector, on, props} from '@ngrx/store';
import {State as AppState} from '../../state';
import * as noteSelectors from '../courses/selectors';

export const saveNotes = createAction('[Notes] Save Note', props<{courseId: string, lectureId: string, noteContent: string}>());
export const getNotesComplete = createAction('[Notes] Set Note', props<{courseId: string, lectureId: string, noteContent: string}>());
export const getNotes = createAction('[Notes] Get Note', props<{courseId: string, lectureId: string}>());

export const startSaving = createAction('[Notes] Start Saving');
export const doneSaving = createAction('[Notes] Done Saving');

export interface State {
	notesMap: {[key: string]: string};
	isSaving: boolean;
	lastSavedDate: Date;
}
export const initialState: State = {
	notesMap: {},
	isSaving: false,
	lastSavedDate: new Date(),
};

export const notesReducer = createReducer(
	initialState,
	on(getNotesComplete, (state, action) => ({...state, notesMap: {
			...state.notesMap,
			[action.lectureId]: action.noteContent
		}
	})),
	on(startSaving, state => ({...state, isSaving: true})),
	on(doneSaving, state => ({...state, isSaving: false, lastSavedDate: new Date()})),
);

export function reducer(state: State|undefined, action: Action) {
	return notesReducer(state, action);
}

export const selectLectureNotes = createSelector(
	(state: AppState) => state.notes,
	(state: AppState) => noteSelectors.getCurrentLesson(state.course),
	(notes, currentLesson) => currentLesson && notes.notesMap[currentLesson.system_id]
);

export const selectNotesSaveStatus = createSelector(
	(state: AppState) => state.notes,
	(notes) => ({isSaving: notes.isSaving, savedAt: notes.lastSavedDate})
);

